import React from 'react';
import loadable from '@loadable/component';
import { fullLoadingWithText } from './components/molecules/page/PageLoader';
import withClearCache from './withClearCache';

const SessionInitalizer = loadable(() => import('./components/organism/init/SessionInitalizer'), {
  fallback: fullLoadingWithText('Downloading Resources'),
});

const Pages = loadable(() => import('./pages'), {
  fallback: fullLoadingWithText('Loading Pages'),
});

const MainApp: React.FC = () => {
  return (
    <SessionInitalizer>
      <Pages />
    </SessionInitalizer>
  );
};

const ClearCacheComponent = withClearCache(MainApp);

const App: React.FC = () => {
  return <ClearCacheComponent />;
};

export default App;
